<template>
  <div class="backimg">
    <div class="search-content" style="width:100%;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item v-for="item in menuList"
                      v-if="(item.menuurl=='StoreDetailListSupply'&&isZongBu()&&financeright)||(item.menuurl!='StoreDetailListSupply')"
                      :key="item.menuurl" :index="item.menuurl">{{item.menuname}}
        </el-menu-item>
        <el-menu-item index="700" v-if="isZongBu()&&financeright&&usereturnflow">待退款<span class="badge"
                                                                                          v-if="statusnumber700>0">{{statusnumber700}}</span>
        </el-menu-item>
        <el-menu-item index="750" v-if="isZongBu()&&financeright&&usereturnflow">已退款</el-menu-item>
        <el-menu-item index="810" v-if="isZongBu()&&financeright&&usereturnflow">采购待审核
          <span class="badge" v-if="statusnumber810>0">{{statusnumber810}}</span>
        </el-menu-item>
        <!--<el-menu-item index="all" v-if="financeright">全部</el-menu-item>-->
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <router-view :roletype="'jiesuan'" :mystatus="status" @bindTip="bindTip" v-if="visible"
                   :shoudongcaigou="invoicesource"></router-view>
    </el-main>
  </div>
</template>
<script>
  import {countlist} from '@/api/set/csagreement';
  import {getMenu, checkModuleRight} from '@/api/login'

  export default {
    data() {
      return {
        activeIndex: "",
        statuseslist: "700;810;",
        status: "",
        invoicesource: '',//手动采购  1未审核 2审核通过
        visible: true,
        searchContentHeight: 50,
        statusnumber700: 0,
        statusnumber810: 0,
        userInfoModel: [],
        financeright: false,//拥有财务权限
        usereturnflow: false,
        menuList: [],//菜单
      };
    },
    methods: {
      isZongBu() {//只有总部人员能操作
        return this.userInfoModel.independentserial == null || this.userInfoModel.independentserial == ""
      },
      handleSelect(key, keyPath) {
        this.status = key
        if (key == '810') {
          this.invoicesource = 1
        }
        this.visible = false
        this.$nextTick(() => {
          if (key == "700" || key == "750" || key == "all" || key == '810') {
            // this.currentcomponent = "CstagreementList"
            this.$router.push({name: "CstagreementList"})
          } else {
            // this.currentcomponent = key
            this.$router.push({name: key})
          }
          this.visible = true
        })
      },
      bindTip() {
        this.statusnumber700 = 0
        this.statusnumber810 = 0
        countlist({statuseslist: this.statuseslist}).then(response => {
          response.data.obj.forEach(item => {
            if (item.status == 700) {
              this.statusnumber700 = item.number
            } else if (item.status == 810) {
              this.statusnumber810 = item.number
            }
          })
        })
      },
      getMenuList() {
        getMenu({
          MenuCode: this.$route.params.menucode,
          AppGuid: (localStorage.getItem("appguid") || "")
        }).then(response => {
          this.menuList = response.data.menu;
          if (this.menuList.length > 0) {
            var url = this.menuList[0].menuurl;
            this.$router.push({name: url})
            this.activeIndex = url
            this.status = url
          }
        }).catch((error) => {
          console.log(error)
        });
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      this.financeright = this.$checkRight("财务")
      this.getMenuList()
      // if (this.isZongBu() && this.financeright) {
      //   // this.currentcomponent = "CstagreementList"
      //   this.$router.push({name: "CstagreementList"})
      //   this.activeIndex = '700'
      //   this.status = '700'
      //   this.bindTip()
      // } else {
      // this.currentcomponent = "StoreDetailListCustomer"

      // }
      //退货功能
      checkModuleRight({name: 'usereturnflow'}).then(reponse => {
        this.usereturnflow = reponse.data.code == 0;
      });
    },
    components: {}
  }
</script>
<style scoped>

  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width: 100%;
    margin: 0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
    font-size: 13px;
    padding: 0 18px !important;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    background: linear-gradient(135deg, #f8f9fc 0%, #eef1f7 100%);
    border-radius: 6px 6px 0 0;
    padding: 0 4px;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    background: transparent;
    color: #409eff;
  }

  .el-menu--horizontal .el-menu-item.is-active {
    border-bottom: 3px solid #409eff !important;
    color: #222 !important;
    font-weight: 600;
    background: transparent !important;
  }

  .el-menu--horizontal .el-menu-item .badge {
    display: inline-block;
    line-height: 16px;
    font-size: 11px;
    min-width: 16px;
    height: 16px;
    background: linear-gradient(135deg, #f56c6c, #e24545);
    color: #fff;
    text-align: center;
    border-radius: 8px;
    position: relative;
    top: -8px;
    margin-left: 3px;
    padding: 0 4px;
    box-shadow: 0 2px 4px rgba(245,108,108,0.3);
  }

  .el-submenu__title, .el-submenu {
    height: 48px !important;
    line-height: 48px !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/account/JieSuan.vue